import {reactFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {BulkActionQueryTarget} from '@github-ui/item-picker-base/ItemPicker'
import {UpdateIssuesBulk, UpdateIssuesBulkByQuery} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'
import type {UpdateIssuesBulkByQueryMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulkByQuery'

type UpdateIssueIssueTypeBulkRequestBase = {
  ids: string[]
  queryTarget?: BulkActionQueryTarget
}

type UpdateIssueIssueTypeBulkRequestWithIssueTypeId = UpdateIssueIssueTypeBulkRequestBase & {
  issueTypeId: string
}

type UpdateIssueIssueTypeBulkRequestWithClearIssueType = UpdateIssueIssueTypeBulkRequestBase & {
  clearIssueType: true
}

export type UpdateIssueIssueTypeBulkRequest =
  | UpdateIssueIssueTypeBulkRequestWithIssueTypeId
  | UpdateIssueIssueTypeBulkRequestWithClearIssueType

export type UpdateIssueIssueTypeBulkResponse = GraphQLResponse<
  Partial<UpdateIssuesBulkMutation & UpdateIssuesBulkByQueryMutation>
>

export async function apiUpdateIssueIssueTypeBulk(
  request: UpdateIssueIssueTypeBulkRequest,
): Promise<UpdateIssueIssueTypeBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {
    ...(request.queryTarget ?? {ids: request.ids}),
    queryId: request.queryTarget ? UpdateIssuesBulkByQuery : UpdateIssuesBulk,
  }

  if ('issueTypeId' in request) {
    body.issueTypeId = request.issueTypeId
  } else {
    body.clearIssueType = request.clearIssueType
  }
  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await reactFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueIssueTypeBulkResponse>
}
